import React, { useEffect, useState } from "react";
import { Form, Input, Space, Select, Collapse, List } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getClientTeamDetails, 
	doClientTeamCreate, 
	doClientTeamUpdate, 
	doClientUserCreate,
	doDeleteSupervisor,
} from "../../../../../redux/client/clientState";
import CrudButtons from "components/button/crudbuttons";
import UnassignButton from "components/button/unassignbutton";
import { requiredField, emailField } from "utils/crudSagaHelper";
import { PlusOutlined, DownOutlined } from "@ant-design/icons";
const ClientTeamForm = ({
	doCreate, 
	doUpdate, 
	createClientUser,
	onCancel, 
	recordData,
	clientId,
	getDetails,
	submitLabel,
	doUnassign,
	...props
 }) => {
		
  	const [form] = Form.useForm();
  	const { recordId, mode } = props;
	const [supervisorSelected, setSupervisorSelected] = useState(false);
	const [addUserFilled, setAddUserFilled] = useState(false);
	const [userList, setUserList] = useState([]);
	const [supervisors, setSupervisors] = useState(recordData?.supervisors || []);

	useEffect(() => {
		if (recordData?.userList) {
			setUserList(recordData.userList.map(u => ({ value: u.value, label: u.label })));
		}
	}, [recordData]);

	useEffect(() => {	
		if (recordData) {

			console.log(recordData?.supervisors);
			form.resetFields();
			const {clien_team:clientTeam, ...rest } = recordData;

			const supervisorIds = recordData?.supervisors?.map(s => s.supervisor?.id ?? s.supervisor_id) || [];

			const initialValues = {
			...rest,
			...clientTeam,
			cte_client_id: clientId,
			supervisors: supervisorIds,
			};
			form.setFieldsValue(initialValues);

			setSupervisorSelected(supervisorIds.length > 0);
		}
	}, [recordData, clientId, form]);

	const handleValuesChange = (changed, allValues) => {
		if (changed.clu_user_id !== undefined) {
			setSupervisorSelected(!!changed.clu_user_id);
		}

		const addUserFields = [
			allValues.ude_first_name,
			allValues.ude_last_name,
			allValues.email,
			allValues.clu_job_title,
		];
		setAddUserFilled(addUserFields.some((v) => !!v !== ""));
	};

	useEffect(() => {
		if (clientId && recordId === 0) {
			getDetails({ clientId, teamId: 0 });
		}
	}, [clientId, recordId, getDetails]);
   
  	const onSubmit = async (formData) => {
		try {

        if (!Array.isArray(formData.supervisors)) {
            formData.supervisors = formData.supervisors ? [formData.supervisors] : [];
        }

		recordData?.cte_id > 0 ? doUpdate(formData) : doCreate(formData);

		} catch (error) {
			console.error("Save failed:", error);
		}
	};

  	return (
		<Form className={mode !== "view" ? "form" : ""}
			layout="vertical"
			form={form}
			onFinish={onSubmit}
			onValuesChange={handleValuesChange}
		>   
			<FormItem
				name="cte_client_id"
				hidden
			>
				<Input type="hidden"/>
			</FormItem>
			<FormItem
				name="cte_id"
				hidden
			>
				<Input type="hidden"/>
			</FormItem>
			<div className="form-column-2">  		            	            
				<div className="col-span-1">
					<FormItem className="font-medium mb-2 "
						name="cte_name"
						label="Team Name"
						rules={mode !== "view" && [requiredField]}
						
					>
						{mode !== "view" ?
							<Input id="cte_name"
								placeholder="Team Name"
								className="input-field" 
								maxLength={30}
							/>
							: 
							<label className="text-base label-value dark:text-white">
								{recordData?.cte_name}
							</label>
						}
					</FormItem>
				</div>
			</div>
			<div className="grid grid-cols-3 gap-y-2 gap-x-4 w-full">
				<div className="col-span-2 mb-4">
					<FormItem className="font-medium mb-4 "
						label="Supervisors"
						name="supervisors"
						rules={mode !== "view" && (!addUserFilled ? [requiredField] : [])}
					>
						{mode !== "view" ?
							<Select id="supervisors"
								mode="multiple"
								className="input-field"
								showSearch
								allowClear={true}
								placeholder="Select supervisor"
								optionFilterProp="label"
								onChange={value => setSupervisorSelected(value.length > 0)}
								maxTagCount="responsive"
								style={{ width: "100%"}}
								options={recordData?.userList}
							/>
							: 
							<div >
								<List
									className="text-base label-value dark:text-white"
									dataSource={recordData?.supervisors}
									renderItem={item => (
										<List.Item
											actions={[
												<UnassignButton
													key="unassign"
													supervisorItem={item}
													form={form}
													setSupervisors={setSupervisors}
													setSupervisorSelected={setSupervisorSelected}
													unassignHandler={() =>
														doUnassign({
															cte_client_id: clientId,
															cte_id: recordId,
															cts_id: item?.cts_id,
														})
													}
												/>,
											]}
										>
											{item.supervisor.name}
										</List.Item>
									)}
								>
								</List>
							</div>
						}
					</FormItem>	  
				</div>
			</div>
			
			{!supervisorSelected && mode !== "view" && (
				<Collapse
					defaultActiveKey={mode !== "view" ? ["1"] : []}
					ghost
					className="[&_.ant-collapse-header]:!p-0 [&_.ant-collapse-content-box]:!p-0"
					expandIcon={({ isActive }) => (isActive ? <DownOutlined /> : <PlusOutlined />)}
					items={[
						{
							key: "0",
							label: <span className="text-sm font-medium label-title">Add User</span>,
							children: (
								<div className="pt-2 form-column-2">
									<Space.Compact className="font-medium gap-2 w-full">
										<FormItem
											label="First Name"
											name="ude_first_name"
											rules={[requiredField]}
											className="mb-0 w-1/2"
										>
											{mode !== "view" ? 
												<Input
													id="ude_first_name"
													placeholder="First Name"
													className="input-field"
													maxLength={50}
												/>
												:
												<span className="text-base label-value dark:text-white">
													{recordData?.user?.user_detail?.ude_first_name}
												</span>
											}
										</FormItem>

										<FormItem
											label="Last Name"
											name="ude_last_name"
											rules={[requiredField]}
											className="mb-0 w-1/2"
										>
											{mode !== "view" ? 
												<Input
													id="ude_last_name"
													placeholder="Last Name"
													className="input-field"
													maxLength={50}
												/>
												:
												<span className="text-base label-value dark:text-white">
													{recordData?.user?.user_detail?.ude_last_name}
												</span>
											}
										</FormItem>
									</Space.Compact>

									<FormItem label="Email" name="email" rules={[requiredField, emailField]}>
										{mode !== "view" ? 
											<Input
												id="email"
												placeholder="username@domain.com"
												className="input-field"
												maxLength={50}
											/>
											:
											<span className="text-base label-value dark:text-white">
												{recordData?.user?.email}
											</span>
										}
									</FormItem>

									<FormItem label="Role / Job Title" name="clu_job_title">
										{mode !== "view" ? 
											<Input
												id="clu_job_title"
												className="input-field"
												maxLength={50}
											/>
											: 
											<span className="text-base label-value dark:text-white">
												{recordData?.clu_job_title}
											</span>
										}
									</FormItem>
								</div>
							)
						}
					]}
				/>
			)}
			<div className="w-full flex justify-end dark:">
				{(mode === "edit") && (
					<CrudButtons
						mode={mode}
						recordId={recordData?.cte_id ?? 0}
						isModal={true}
						modalId={recordData?.cte_id > 0 ? 'edit_client_team' : 'add_client_team'}
						cancelLabel="Cancel"
						doHideModal={onCancel}
						submitLabel={submitLabel}
					/>
				)}
			</div>
		</Form>	 	
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.client.clientTeamDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
	getDetails: (data) => dispatch(getClientTeamDetails(data)),
  	doCreate: (data) => dispatch(doClientTeamCreate(data)),
  	doUpdate: (data) => dispatch(doClientTeamUpdate(data)),
	createClientUser: (data) => dispatch(doClientUserCreate(data)),
	doUnassign: (data) => dispatch(doDeleteSupervisor(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientTeamForm);
